import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import React from "react";
import logo from "../../images/logo_fb_white.png";

export default function FacebookButton(props) {
  return (
    <Button variant="contained" onClick={props.click} style={{ backgroundColor: "#3b5998", width: 240, margin: 5, justifyContent:"center"}}>
      <img src={logo} className={"App-login-button"} alt="logo" height={30} />
      <Typography style={{ textTransform: "none", color: "#fff", paddingLeft: 15, width: 180 }}>Sign in with Facebook</Typography>
    </Button>
  );
}
